import {LiveCasinoNavbarOverflowDefaultBox} from "./live-casino-navbar-overflow.default.box";

export const LiveCasinoNavbarOverflowBox =LiveCasinoNavbarOverflowDefaultBox;